import * as React from 'react';
import { createSelectable, TSelectableItemProps } from '../../../components/drag-select';
import { toSlashedShortDate } from '../../../utils/date-utils';
import { OrderSummary } from '../../models/shared/order-summary';

interface IProps extends TSelectableItemProps {
    orderItem: OrderSummary;
}

export const ShipmentActionAddOrderRow = (props : IProps) => {

    const { selectableRef, 
        isSelected, 
        isSelecting, 
        orderItem
     } = props;

     let actualClass = 'order-selectable';
     actualClass += (orderItem.isChecked) ? ' highlight' : '';
     actualClass += (isSelecting) ? ' dragging' : '';
     actualClass += (isSelected) ? ' selected-already' : '';
        
    return orderItem 
            ? <tr key={orderItem.id} 
                ref={selectableRef} 
                className={ actualClass }>
                <td>
                    <input
                        type="checkbox"
                        checked={orderItem.isChecked}
                        onChange={() => { return; }}
                    />
                </td>
                <td>{ orderItem.id }</td>
                <td>{ orderItem.description }</td>
                <td>{ orderItem.jobName }</td>
                <td>{ orderItem.cutoffDate ? toSlashedShortDate(orderItem.cutoffDate) : '' }</td>
            </tr>
        : <tr/>;

};

export default createSelectable(ShipmentActionAddOrderRow);
